(() => {
  const script = document.currentScript;
  const moduleUrl = script?.dataset.vdpoModule ? new URL(script.dataset.vdpoModule, document.baseURI).href : null;
  for (const host of document.querySelectorAll('[data-vdpo-stock]')) {
    if (host.dataset.vdpoLoadingStarted) continue;
    host.dataset.vdpoLoadingStarted = 'true';
    const section = host.closest('product-info') || host.closest('section');
    // A failed module graph must never expose the theme's incomplete native configuration.
    for (const element of section?.querySelectorAll('variant-selects,variant-radios,product-form,quantity-input') || []) {
      element.hidden = true;
      element.style.display = 'none';
    }
    // Temporary owner-approved fulfillment hold; identity comes from the server-rendered binding.
    const holdPacket = host.querySelector('script[type="application/json"]');
    const holdData = holdPacket ? JSON.parse(holdPacket.textContent) : null;
    const heldIds = new Set(["gid://shopify/Product/16193921909039","gid://shopify/Product/16193922236719","gid://shopify/Product/16193922597167","gid://shopify/Product/16193922892079","gid://shopify/Product/16193923186991","gid://shopify/Product/16193923318063","gid://shopify/Product/16193923744047","gid://shopify/Product/16193924202799","gid://shopify/Product/16193924596015","gid://shopify/Product/16193925087535"]);
    const heldProfile = holdData?.binding?.runtime;
    if (heldProfile && heldIds.has(heldProfile.productId) && heldProfile.productId === 'gid://shopify/Product/' + holdData.productId && heldProfile.shop === holdData.shop && heldProfile.productClass === 'STOCK_CATALOG_PRODUCT' && heldProfile.checkoutReady === false) {
      host.dataset.vdpoReady = 'false';
      host.dataset.vdpoLoadState = 'purchase-hold';
      host.setAttribute('aria-busy', 'false');
      for (const control of host.querySelectorAll('input,select,button')) control.disabled = true;
      for (const payment of host.querySelectorAll('[data-vdpo-native-payment]')) { payment.hidden = true; payment.inert = true; }
      const message = host.querySelector('[data-vdpo-loading]');
      if (message) { message.setAttribute('role','alert'); message.textContent = 'This product is temporarily unavailable while we update its options. Please check back soon, or contact us for help.'; }
      const blocked = document.createElement('button'); blocked.type = 'button'; blocked.disabled = true; blocked.className = 'button button--full-width button--primary'; blocked.textContent = 'Temporarily unavailable'; host.append(blocked);
      continue;
    }
    let expired = false;
    function unavailable(code) {
      expired = true;
      host.dataset.vdpoReady = 'false';
      host.dataset.vdpoLoadState = 'error';
      host.setAttribute('aria-busy', 'false');
      for (const input of host.querySelectorAll('input,select,button')) input.disabled = true;
      for (const payment of host.querySelectorAll('[data-vdpo-native-payment]')) {
        payment.hidden = true;
        payment.inert = true;
      }
      const message = host.querySelector('[data-vdpo-loading]') || document.createElement('div');
      message.dataset.vdpoLoading = '';
      message.setAttribute('role', 'alert');
      message.textContent = 'Product options are temporarily unavailable. Please reload to try again before purchasing.';
      const retry = document.createElement('button');
      retry.type = 'button';
      retry.textContent = 'Reload product options';
      retry.addEventListener('click', () => window.location.reload(), {once: true});
      message.append(retry);
      if (!message.parentNode) host.append(message);
      console.error('[VDPO]', {stage: 'options-initialization', code});
    }
    const timer = setTimeout(() => unavailable('OPTIONS_TIMEOUT'), 12000);
    Promise.resolve().then(() => {
      if (!moduleUrl) throw Error('Missing module URL');
      return import(moduleUrl);
    }).then(module => {
      if (expired) return;
      module.initializeStockHost(host);
      if (host.dataset.vdpoReady !== 'true') throw Error('Renderer did not mount');
      host.dataset.vdpoLoadState = 'ready';
      clearTimeout(timer);
    }).catch(error => {
      clearTimeout(timer);
      if (!expired) { console.error('[VDPO initialization]', error.name, error.message); unavailable('OPTIONS_INITIALIZATION_FAILED'); }
    });
  }
})();


